import React from 'react';
export function ComparativeReportIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13a5.5 5.5 0 10-4.566-2.433l-1.367 1.367a5.5 5.5 0 101.43 1.398l1.335-1.336A5.474 5.474 0 0016.5 13zm-9 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"
  }));
}